import { Pipe, PipeTransform } from '@angular/core';
import { formatFileSize } from 'src/app/utils/file.utils';

@Pipe({
    name: 'fileSize',
    standalone: false
})
export class FileSizePipe implements PipeTransform {

    transform(value: number, startFrom: string = 'octets'): string {
        return formatFileSize(value, startFrom);
    }
}
